import { useContext } from "react";
import AuthenticationContext from "./Auth/AuthenticationContext";
import Authorized from "./Auth/Authortized";
import { logout } from "./Auth/handleJWT";
import Login from "./Auth/Login";
import Button from "./Utils/Button";

export default function LandingPage() {
    const { update, claims } = useContext(AuthenticationContext);

    function getFullName(): string {
        return claims.filter(x => x.name === "fullName")[0]?.value;
    }
    return (
        <>

                    <div className="container">
{/*                        <h3 className="text-center align-middle">Welcome  {getFullName()}</h3>*/}
{/*                        <div className="w-25 mb-3">Current Client:<ClientSelect /> </div>*/}
                        {/*<Button className="btn btn-primary"*/}
                        {/*    onClick={() => {*/}
                        {/*        logout();*/}
                        {/*        update([]);*/}
                        {/*    }}*/}
                        {/*>Log out</Button>*/}
                    </div>


        </>
    )
}